
import { createRoot } from 'react-dom/client'
import { ClerkProvider } from '@clerk/clerk-react'
import App from './App.tsx'
import './index.css'
import * as Sentry from "@sentry/react";

// Public consumer routes (/o/<code>, /l/<code>) load with no Clerk session and
// must not run third-party trackers (OP-1). Session Replay is the one Sentry
// integration that records DOM/network activity, so it is skipped there;
// error capture (Sentry.init itself) stays on everywhere.
const isPublicConsumerRoute = /^\/(o|l)\//.test(window.location.pathname);

Sentry.init({
  dsn: "https://a51b75bed10e50bfe3605e8eb32a74b7@o4509537888043008.ingest.us.sentry.io/4510563649191936",
  integrations: [
    Sentry.browserTracingIntegration(),
    ...(isPublicConsumerRoute ? [] : [Sentry.replayIntegration()]),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/okswnspuiirygzzmoxmf\.supabase\.co\/functions\/v1\//],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});


const PUBLISHABLE_KEY = "pk_test_YXBwYXJlbnQtc3BvbmdlLTkwLmNsZXJrLmFjY291bnRzLmRldiQ";

if (!PUBLISHABLE_KEY) {
  throw new Error("Missing Clerk Publishable Key");
}

createRoot(document.getElementById("root")!).render(
  <ClerkProvider publishableKey={PUBLISHABLE_KEY}>
    <App />
  </ClerkProvider>
);
